import _ from 'lodash';
import getConfig from './index/configuration';
import { value } from './index/value';
import stripDelimiter from './index/stripDelimiter';

// adding a comment to get a fresh commit

function configuration<ReturnType>(
  pathParts: string | readonly string[],
): ReturnType | undefined;
function configuration<ReturnType>(
  pathParts: string | readonly string[],
  defaultValue: ReturnType,
): ReturnType;
function configuration<ReturnType>(
  pathParts: string | readonly string[],
  defaultValue: ReturnType | undefined = undefined,
): ReturnType | undefined {
  const config = getConfig();
  const cleanScope = stripDelimiter(config.scope, config.delimiter);
  const cleanPathParts = stripDelimiter(_.flatten([pathParts]), config.delimiter);
  return value(
    cleanPathParts,
    config.settings,
    cleanScope,
    defaultValue,
  );
}

export default configuration;
